import React from 'react';
import { MenuEditor } from './MenuEditor';
import { groceryMenuApi } from '../services/resortAdminApi';

// Grocery menu editor — the shared <MenuEditor/> bound to the grocery admin API
// (api.resort_admin_grocery_menu). Grocery menus mirror restaurant menus but
// have no AI photo-import, so that button is hidden automatically.
export const GroceryMenu: React.FC = () => <MenuEditor menuApi={groceryMenuApi} />;

export default GroceryMenu;
